// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3PTnw","signatureButtonsRight":"ModalSign_signatureButtonsRight__GtRfu"};